import * as TYPES from './CourtsList.types';

const initialState = {
  courtsList: [],
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_COURTS_LIST_SUCCESS: {
      const list = action.result.data.map((item) => {
        return {
          id: item.id,
          ...item.attributes,
          text: item.attributes.text.split(/\t\n|\n/),
        };
      });
      return {
        ...state,
        courtsList: list,
      };
    }

    default:
      return state;
  }
};

export default reducer;
